export const NAME_COLUMN = { name: 'Inventory ID', field: 'id' }
export const LOT_COLUMN = { name: 'Lots', field: 'lots' }

export const columnDefinitions = [
  NAME_COLUMN,
  { name: 'Inventory Name', field: 'name', sortable: true },
  { name: 'Incoming', field: 'awaiting' },
  { name: 'On Hand', field: 'onHand', sortable: true },
  { name: 'Committed', field: 'committed' },
  { name: 'Fulfillable', field: 'fulfillable' },
  { name: 'Exception', field: 'exception' },
  { name: 'Sellable', field: 'totalSellable' },
  { name: 'Backordered', field: 'backordered' },
  { name: 'Internal Transfer', field: 'internalTransfer' },
  LOT_COLUMN
]

export const hubColumnDefinitions = [
  NAME_COLUMN,
  { name: 'Inventory Name', field: 'name', sortable: true },
  { name: 'Incoming', field: 'awaiting' },
  { name: 'Internal Transfer', field: 'internalTransfer' },
  { name: 'On Hand', field: 'onHand', sortable: true },
  { name: 'Committed', field: 'committed' },
  { name: 'Fulfillable', field: 'fulfillable' },
  { name: 'Exception', field: 'exception' },
  { name: 'Sellable', field: 'totalSellable' },
  { name: 'Backordered', field: 'backordered' },
  LOT_COLUMN
]

export const statusViewDefaultColumnDefinitions = [
  NAME_COLUMN,
  { name: 'Inventory Name', field: 'name', sortable: true },
  { name: 'Total Inventory', field: 'awaiting' },
  LOT_COLUMN
]

export const defaultSortColumn = NAME_COLUMN
export const defaultSortOrdering = 'asc'

export const sortableFields = columnDefinitions.filter(cd => cd.sortable).map(cd => cd.field)

export const columnDefinitionFromField = (field) => columnDefinitions.find(cd => cd.field === field)
export const statusViewColumnDefinitionFromField = (field) => statusViewDefaultColumnDefinitions.find(cd => cd.field === field)

export const modalDefinitions = [
  { name: 'Lot #', field: 'lotNumber' },
  { name: 'Exp Date', field: 'expirationDate' },
  { name: 'Incoming', field: 'awaiting' },
  { name: 'On Hand', field: 'onHand' },
  { name: 'Committed', field: 'committed' },
  { name: 'Fulfillable', field: 'fulfillable' },
  { name: 'Exception', field: 'exception' },
  { name: 'Backordered', field: 'backordered' },
  { name: 'Internal Transfer', field: 'internalTransfer' }
]

export const modalHubDefinitions = [
  { name: 'Lot #', field: 'lotNumber' },
  { name: 'Exp Date', field: 'expirationDate' },
  { name: 'Incoming', field: 'awaiting' },
  { name: 'Internal Transfer', field: 'internalTransfer' },
  { name: 'On Hand', field: 'onHand' },
  { name: 'Committed', field: 'committed' },
  { name: 'Fulfillable', field: 'fulfillable' },
  { name: 'Exception', field: 'exception' },
  { name: 'Backordered', field: 'backordered' }
]

export const filterTabDefinitions = [
  { name: 'On Hand', field: 'onHand', view: { active: true, bundle: true } },
  { name: 'Committed', field: 'committed', view: { active: true, bundle: true } },
  { name: 'Fulfillable', field: 'fulfillable', view: { active: true, bundle: true } },
  { name: 'Incoming', field: 'awaiting', view: { active: true, bundle: false } },
  { name: 'Exception', field: 'exception', view: { active: true, bundle: false } },
  { name: 'Sellable', field: 'sellable', view: { active: true, bundle: false } },
  { name: 'Backordered', field: 'backordered', view: { active: true, bundle: false } },
  { name: 'Internal Transfer', field: 'internalTransfer', view: { active: true, bundle: false } }
]

export const supportedTableOptions = [
  { name: 'active' },
  { name: 'bundle' }
]

export const disabledStatusTabDefinitions = [
  { name: 'Exception', field: 'exception' },
  { name: 'Backordered', field: 'backordered' },
  { name: 'Sellable', field: 'sellable' }
]
